// Homepage
import CheckBaoHanh from '../components/home/index';
import KichHoat from '../components/view/kichHoat';
import TraCuu from '../components/view/traCuu';
import YeuCau from '../components/view/yeuCau';
import TramBaoHanh from '../components/view/tramBaoHanh';
import HuongDan from '../components/view/huongDan';
import PhieuBaoHanh from '../components/view/phieuBaoHanh';
import ThoiHanBaoHanh from '../components/view/thoiHanBaoHanh';
import ChinhSachBaoHanh from '../components/view/chinhSachBaoHanh';
import TraCuuTinhTrangBaoHanh from '../components/view/tracuutinhtrangbaohanh';
import YeuCauDetail from '../components/view/yeucaudetail';
import TraCuuDetail from '../components/view/tracuuDetail';
import PhuKien from '../components/view/phuKien';
import HuongDanSuDung from '../components/view/huongDanSuDung';
import chinhSachBaoMat from '../components/view/chinh-sach/chinhSachBaoMat';
import chinhSachHuyDoiTraHoanTien from '../components/view/chinh-sach/chinhSachHuyDoiTraHoanTien';
import chinhSachThanhToan from '../components/view/chinh-sach/chinhSachThanhToan';
import chinhSachVanChuyen from '../components/view/chinh-sach/chinhSachVanChuyen';
import DieuKhoanChungPage from '../components/view/chinh-sach/dieuKhoanChung';
import HuongDanKhacPhucLoi from '../components/view/khac-phuc-loi/huongDanKhacPhucLoi';
import DanhMucSanPham from '../components/view/khac-phuc-loi/danhMucSanPham';
import ChiTietKhacPhuc from '../components/view/khac-phuc-loi/chiTietKhacPhuc';
import LapDatTaiNha from '../components/view/dangKyLapDatTaiNha';

export const routes = [
  { path: '/homepage', Component: CheckBaoHanh },
  { path: '/kich-hoat-bao-hanh', Component: KichHoat },
  { path: '/tra-cuu-bao-hanh', Component: TraCuu },
  { path: '/tra-cuu-bao-hanh-detail/:sdt/:sochungtu', Component: TraCuuDetail },
  { path: '/gui-yeu-cau', Component: YeuCau },
  { path: '/chinh-sach-bao-hanh', Component: ChinhSachBaoHanh },
  { path: '/khuyen-cao-su-dung', Component: HuongDan },
  { path: '/thoi-han-bao-hanh', Component: ThoiHanBaoHanh },
  { path: '/tram-bao-hanh/:slug', Component: TramBaoHanh },
  { path: '/phieu-bao-hanh/:id', Component: PhieuBaoHanh },
  { path: '/tra-cuu-tinh-trang-bao-hanh', Component: TraCuuTinhTrangBaoHanh },
  { path: '/gui-yeu-cau/:id', Component: YeuCauDetail },
  { path: '/phu-kien', Component: PhuKien },
  { path: '/yeu-cau-ho-tro', Component: HuongDanSuDung },
  { path: '/huong-dan-khac-phuc-loi', Component: HuongDanKhacPhucLoi },
  { path: '/danh-muc-san-pham', Component: DanhMucSanPham },
  { path: '/chi-tiet-khac-phuc', Component: ChiTietKhacPhuc },
  { path: '/chinh-sach-bao-mat', Component: chinhSachBaoMat },
  { path: '/chinh-sach-huy-doi-tra', Component: chinhSachHuyDoiTraHoanTien },
  { path: '/chinh-sach-thanh-toan', Component: chinhSachThanhToan },
  { path: '/chinh-sach-van-chuyen', Component: chinhSachVanChuyen },
  { path: '/dieu-khoan-chung', Component: DieuKhoanChungPage },
  { path: '/lap-dat-tai-nha', Component: LapDatTaiNha },
];
